module.exports = __webpack_public_path__ + "static/media/r6s2.0428541f.jpg";